import React, { useState, useEffect } from 'react';
import api from '../axios';
import { CodeBlock, noctisViola } from 'react-code-blocks'; // Import CodeBlock and theme

const my_style = noctisViola;

const SnippetDetails = ({ snippetId }) => {
  const [snippet, setSnippet] = useState(null); // Stores the snippet object
  const [isEditing, setIsEditing] = useState(false); // Tracks edit mode
  const [error, setError] = useState(null); // Tracks errors
  const [success, setSuccess] = useState(false); // Tracks successful updates


  useEffect(() => {
    if (snippetId) {
      const fetchSnippet = async () => {
        console.log(`Fetching snippet with ID: ${snippetId}`);

        try {
          const response = await api.get(`/api/snippets/${snippetId}`);
          console.log("Fetched snippet:", response.data);
          setSnippet(response.data.snippet);
        } catch (err) {
          console.error('Error fetching snippet:', err);

          if (err.response) {
            console.error("Response Status:", err.response.status);
            console.error("Response Data:", err.response.data);
          }
        }
      };

      fetchSnippet();
    }
  }, [snippetId]);

  
  const toggleArchive = async () => {
    try {
      const response = await api.patch(`/api/snippets/${snippet.id}/archive`);
      setSnippet({ ...snippet, archived: response.data.archived });
    } catch (err) {
      console.error('Error toggling archive:', err);
    }
  };

  const toggleFavorite = async () => {
    try {
      const response = await api.patch(`/api/snippets/${snippet.id}/favorite`);
      setSnippet({ ...snippet, favorite: response.data.favorite });
    } catch (err) {
      console.error('Error toggling favorite:', err);
    }
  };

  const handleSave = async () => {
    setError(null);
    setSuccess(false);

    try {
      const response = await api.put(`/api/snippets/${snippetId}`, snippet);
      setSnippet(response.data);
      setSuccess(true);
      setIsEditing(false); // Exit edit mode
    } catch (err) {
      console.error('Error updating snippet:', err);
      setError('Failed to update snippet.');
    }
  };

  if (!snippet) return <div>Select a snippet to view details</div>;

  return (
    <div style={{ padding: '10px' }}>
      <h4>Snippet Details</h4>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>Snippet updated successfully!</p>}

      {isEditing ? (
        <div>
          <div>
            <label>Title:</label>
            <div>
              <input
                type="text"
                value={snippet.title}
                onChange={(e) => setSnippet({ ...snippet, title: e.target.value })}
                style={{ width: '250px', marginBottom: '10px' }}
              />
            </div>
          </div>
          <div>
            <label>Language:</label>
            <div>
              <input
                type="text"
                value={snippet.language}
                onChange={(e) =>
                  setSnippet({ ...snippet, language: e.target.value })
                }
                style={{ width: '250px', marginBottom: '10px' }}
              />
            </div>
          </div>
          <div>
            <label>Tags (comma-separated):</label>
            <div>
              <input
                type="text"
                value={snippet.tags?.join(', ') || ''}
                onChange={(e) =>
                  setSnippet({
                    ...snippet,
                    tags: e.target.value.split(',').map((tag) => tag.trim()),
                  })
                }
                style={{ width: '450px', marginBottom: '10px' }}
              />
            </div>
          </div>
          <div>
            <label>Content:</label>
            <div>
              <textarea
                value={snippet.content}
                onChange={(e) =>
                  setSnippet({ ...snippet, content: e.target.value })
                }
                style={{
                  width: '650px',
                  height: '250px',
                  fontFamily: 'monospace',
                  fontSize: '12px',
                }}
              />
            </div>
          </div>
          <button onClick={handleSave} style={{ marginRight: '10px' }}>
            Save
          </button>
          <button onClick={() => setIsEditing(false)}>Cancel</button>
        </div>
      ) : (
        <div>
          <p>
            <strong>Title:</strong> {snippet.title}
          </p>
          <p>
            <strong>Language:</strong> {snippet.language}
          </p>
          <p>
            <strong>Tags:</strong> {snippet.tags?.join(', ') || 'No tags'}
          </p>
          <label>
            <input
              type="checkbox"
              checked={!!snippet.archived} // Use double-bang to ensure boolean value 
              onChange={toggleArchive}
            />
            Archive
          </label>
          <label>
            <input
              type="checkbox"
              checked={!!snippet.favorite} // Use double-bang to ensure boolean value
              onChange={toggleFavorite}
            />
            Favorite
          </label>
          <div
          style={{
            width: '700px', // Initial width
            height: '500px', // Initial height
            overflow: 'auto', // Enable scrolling when needed
            border: '1px solid #ccc',
            padding: '1px',
            fontFamily: 'monospace',
            //background: '#f9f9f9',
            resize:'both',  //Allows for resize of text window
            position: 'relative', // Ensure scrollbars stay within the container
          }}
          >
            <CodeBlock
              text={snippet.content}
              language={snippet.language || 'text'}
              theme={my_style}
              showLineNumbers={true}
              wrapLines={true}
              codeBlock
              customStyle={{
                width: '100%', // Match container width
                height: '100%', // Match container height
                whiteSpace: 'pre-wrap', // Preserve spacing while wrapping long lines
                overflow: 'scroll', // Let the parent container handle scrollbars
              }}
            />
          </div>
          <button
            onClick={() => setIsEditing(true)}
            style={{ marginTop: '10px' }}
          >
            Edit
          </button>
        </div>
      )}
    </div>
  );
};

export default SnippetDetails;
